module.exports = __webpack_public_path__ + "img/cost-icon__storage.38d4d01e.svg";